import { render, staticRenderFns } from "./ElButton.vue?vue&type=template&id=6a42ef44&scoped=true&"
import script from "./ElButton.vue?vue&type=script&lang=js&"
export * from "./ElButton.vue?vue&type=script&lang=js&"
import style0 from "./ElButton.vue?vue&type=style&index=0&id=6a42ef44&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a42ef44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/inspireyourtribe.salamander.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a42ef44')) {
      api.createRecord('6a42ef44', component.options)
    } else {
      api.reload('6a42ef44', component.options)
    }
    module.hot.accept("./ElButton.vue?vue&type=template&id=6a42ef44&scoped=true&", function () {
      api.rerender('6a42ef44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/forms/ElButton.vue"
export default component.exports